/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessBiomarkerFileDto
 */
export interface ProcessBiomarkerFileDto {
    /**
     * Firebase Storage file path or URL
     * @type {string}
     * @memberof ProcessBiomarkerFileDto
     */
    filePath: string;
}

/**
 * Check if a given object implements the ProcessBiomarkerFileDto interface.
 */
export function instanceOfProcessBiomarkerFileDto(value: object): value is ProcessBiomarkerFileDto {
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    return true;
}

export function ProcessBiomarkerFileDtoFromJSON(json: any): ProcessBiomarkerFileDto {
    return ProcessBiomarkerFileDtoFromJSONTyped(json, false);
}

export function ProcessBiomarkerFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessBiomarkerFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filePath': json['filePath'],
    };
}

export function ProcessBiomarkerFileDtoToJSON(json: any): ProcessBiomarkerFileDto {
    return ProcessBiomarkerFileDtoToJSONTyped(json, false);
}

export function ProcessBiomarkerFileDtoToJSONTyped(value?: ProcessBiomarkerFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filePath': value['filePath'],
    };
}

